// src/Components/CategoryIcon.jsx
import React from "react";

const iconBase = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const ICONS = {
  // 1) Tools
  tools: (
    <svg {...iconBase}>
      <path d="M5 4a4 4 0 0 1 6 3.5L9 9.5l5 5 2-2a1.5 1.5 0 0 1 2.1 2.1l-3 3a1.5 1.5 0 0 1-2.1 0l-5-5-2 2A4 4 0 0 1 4 11" />
      <circle cx="6" cy="6" r="1" />
    </svg>
  ),


  // 2) Equipment
  equipment: (
    <svg {...iconBase}>
      <rect x="4" y="8" width="16" height="10" rx="2" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
      <circle cx="9" cy="13" r="1.3" />
      <circle cx="15" cy="13" r="1.3" />
    </svg>
  ),

  // 3) Painting
  painting: (
    <svg {...iconBase}>
      <rect x="4" y="4" width="10" height="6" rx="2" />
      <path d="M14 6h4" />
      <path d="M9 10v4.5a2.5 2.5 0 0 0 5 0V12" />
    </svg>
  ),

  // 4) Coatings
  coatings: (
    <svg {...iconBase}>
      <path d="M12 3l7 4v5c0 4-3 7-7 9-4-2-7-5-7-9V7z" />
      <path d="M10 11.5c.6-.7 1.2-1.2 2-1.2s1.4.5 2 1.2C14.5 12.2 15 13 15 14a3 3 0 0 1-6 0c0-1 .5-1.8 1-2.5z" />
    </svg>
  ),

  // 5) Cement
  cement: (
    <svg {...iconBase}>
      <rect x="6" y="4" width="12" height="16" rx="2" />
      <path d="M9 8h6" />
      <path d="M9 12h6" />
      <path d="M10 16h4" />
    </svg>
  ),

  // 6) Plumbing
  plumbing: (
    <svg {...iconBase}>
      <path d="M5 5h6v4H9v6a3 3 0 0 1-3 3" />
      <path d="M19 5h-6v4h2v6a3 3 0 0 0 3 3" />
      <path d="M5 9v-2" />
      <path d="M19 9v-2" />
    </svg>
  ),

  // 7) Safety
  safety: (
    <svg {...iconBase}>
      <path d="M12 4a5 5 0 0 0-5 5v2h10V9a5 5 0 0 0-5-5z" />
      <path d="M7 11v2a5 5 0 0 0 10 0v-2" />
      <path d="M9 18h6" />
    </svg>
  ),

  // 8) Formwork
  formwork: (
    <svg {...iconBase}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 4v16" />
      <path d="M15 4v16" />
      <path d="M4 10h16" />
      <path d="M4 14h16" />
    </svg>
  ),

  // 9) Lighting
  lighting: (
    <svg {...iconBase}>
      <path d="M9 17a4 4 0 0 1 6 0" />
      <path d="M10 20h4" />
      <path d="M12 4a5 5 0 0 0-3 8.7c.6.5 1 1.1 1 1.8v.5h4v-.5c0-.7.4-1.3 1-1.8A5 5 0 0 0 12 4z" />
    </svg>
  ),
};

export function CategoryIcon({ name, className = "" }) {
  if (!name) return null;
  const key = String(name).toLowerCase().trim();
  const icon = ICONS[key];

  if (!icon) {
    return (
      <div
        className={`w-6 h-6 rounded-full border border-slate-300 flex items-center justify-center text-[10px] text-slate-400 ${className}`}
      >
        ?
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      {icon}
    </div>
  );
}
